import paginacaoListagem from '@/core/store/default/paginacaoListagem'
import { filtroVigenciaAta, opcaoSimNao } from '@/core/constants'

export default {
	paginacao: paginacaoListagem([], 25),
	informacoesAta: { processo: {} },
	filtroSimpleSearch: {
		numeroDescricaoAtaCodigoDescricaoItem: {
			default: null,
			label: 'Pesquisa',
			value: null,
		},
	},
	filtro: {
		numeroDescricaoAtaCodigoDescricaoItem: {
			default: null,
			label: 'Pesquisa',
			value: null,
		},
		isAtaAdesao: {
			default: opcaoSimNao.NAO.value,
			label: 'Atas Caronas',
			value: opcaoSimNao.NAO.value,
		},
		orgaoParticipante: {
			default: null,
			label: 'Órgão Participante',
			value: null,
		},
		orgaoGerenciador: {
			default: null,
			label: 'Órgão Gerenciador',
			value: null,
		},
		anoInicioValidade: {
			default: null,
			label: 'Início validade',
			value: null,
		},
		anoFimValidade: {
			default: null,
			label: 'Fim validade',
			value: null,
		},
		vigenciaAta: {
			default: filtroVigenciaAta.VIGENTES.value,
			label: 'Atas',
			value: filtroVigenciaAta.VIGENTES.value,
		},
	},
}
